/**
 * This module is a fork of and modifies:
 * https://github.com/necolas/react-native-web
 *
 * The original source is (c) Nicolas Gallagher
 * and licensed under the MIT license found a
 * https://github.com/necolas/react-native-web/blob/master/LICENSE
 */
import ExecutionEnvironment from "fbjs/lib/ExecutionEnvironment"

type I18nManagerStatus = {
  allowRTL: (allowRTL: boolean) => void
  doLeftAndRightSwapInRTL: boolean
  forceRTL: (forceRTL: boolean) => void
  isRTL: boolean
  setPreferredLanguageRTL: (setRTL: boolean) => void
  swapLeftAndRightInRTL: (flipStyles: boolean) => void
}

let doLeftAndRightSwapInRTL = true
let isPreferredLanguageRTL = false
let isRTLAllowed = true
let isRTLForced = false

const isRTL = () => {
  if (isRTLForced) {
    return true
  }
  return isRTLAllowed && isPreferredLanguageRTL
}

const onDirectionChange = () => {
  if (ExecutionEnvironment.canUseDOM) {
    if (document.documentElement && document.documentElement.setAttribute) {
      document.documentElement.setAttribute("dir", isRTL() ? "rtl" : "ltr")
    }
  }
}

const I18nManager: I18nManagerStatus = {
  allowRTL(bool) {
    isRTLAllowed = bool
    onDirectionChange()
  },
  forceRTL(bool) {
    isRTLForced = bool
    onDirectionChange()
  },
  setPreferredLanguageRTL(bool) {
    isPreferredLanguageRTL = bool
    onDirectionChange()
  },
  swapLeftAndRightInRTL(bool) {
    doLeftAndRightSwapInRTL = bool
  },
  get doLeftAndRightSwapInRTL() {
    return doLeftAndRightSwapInRTL
  },
  get isRTL() {
    return isRTL()
  },
}

export default I18nManager
